// client/src/features/quotations/MatchReviewBanner.tsx
//
// D99 item 4: "N of M lines need confirmation" above the grid. Hidden at zero. Shown to whoever
// opens the quotation, including one someone else generated. Advisory only - on its own it never
// stops a send. D105.2 changed what it may SAY: while a line is at US$0.00 the quotation cannot be
// sent at all, so the banner must not tell the clerk they still can.

import React from 'react';
import { type MatchLine } from './lineMatchReview';
import { quotationReviewCounts } from '../../utils/matchReasons';

export function MatchReviewBanner({
  items,
  sendBlocked = false,
}: {
  items: MatchLine[] | undefined | null;
  /** True while a line has a missing, US$0.00 or negative selling price (D105.2, D105.7) - the send is refused, so the banner says so. */
  sendBlocked?: boolean;
}) {
  // The same counts the generation notice states (BUSINESS_RULES#quotation-review-counts).
  const { total, needsConfirmation: needConfirmation, notInCatalogue } = quotationReviewCounts(items);
  if (needConfirmation === 0 && notInCatalogue === 0) return null;
  const parts: string[] = [];
  if (needConfirmation > 0) parts.push(`${needConfirmation} of ${total} lines need confirmation`);
  if (notInCatalogue > 0) parts.push(`${notInCatalogue} not in catalogue`);
  return (
    <div
      role="status"
      data-testid="match-review-banner"
      className="mb-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-1.5 text-[13px] text-amber-900"
    >
      {parts.join(' · ')}
      <span className="text-amber-700">
        {sendBlocked
          ? ' — check the highlighted lines first. It cannot be sent while a line has a missing or negative selling price.'
          : ' — you can still send; check the highlighted lines first.'}
      </span>
    </div>
  );
}

export default MatchReviewBanner;
